import { FC, useState } from 'react'
import AccordionText from '../../../common/AccordionText/AccordionText'
import { IParamPick, IProductDetail } from '../../../types'
import styles from './SubSets.module.scss'

import ParamPickerModal from '../../../modals/ParamPickerModal'
import cx from 'classnames'
import ParamPicker from '../ParamPicker/ParamPicker'
import PickerImage from '../ParamPicker/PickerImage'

interface SubSets {
  items: IProductDetail[]
  pickedColors: Record<string, IParamPick>
  pickColor: (setId: string, sku: IParamPick) => void
}
const SubSets: FC<SubSets> = ({ items, pickedColors, pickColor }) => {
  return (
    <div className={styles.accordions}>
      {items.map((item, ind) => {
        const picked = pickedColors[item.id]
        const [open, setOpen] = useState(false)

        return (
          <>
            <AccordionText
              className={cx(
                styles.accordions_desktop,
                ind === items.length - 1 && styles.last,
              )}
              key={item.id}
              titleUppercase
              descriptionClassName={styles.text_description}
              title={
                <span className={styles.accordions_title}>{item.title}</span>
              }
              right={
                picked ? (
                  <PickerImage
                    className={styles.colorImage}
                    imageClassName={styles.colorImageCircle}
                    item={picked}
                  />
                ) : undefined
              }
            >
              <div className={styles.accordions_description}>
                {item.colors?.length > 0 && (
                  <ParamPicker
                    params={item.colors}
                    picked={picked}
                    onPick={(color) => {
                      pickColor(item.id, color)
                    }}
                    type="color"
                  />
                )}
                {item.aromates?.length > 0 && (
                  <ParamPicker
                    params={item.aromates}
                    picked={picked}
                    onPick={(aroma) => {
                      pickColor(item.id, aroma)
                    }}
                    type="aroma"
                  />
                )}
              </div>
            </AccordionText>

            <div
              className={cx(
                styles.accordions_mobile,
                ind === items.length - 1 && styles.last,
              )}
              onClick={() => {
                setOpen(true)
              }}
            >
              <span className={styles.accordions_title}>{item.title}</span>
              <PickerImage
                className={styles.colorImage}
                imageClassName={styles.colorImageCircle}
                item={picked}
              />
            </div>

            <ParamPickerModal
              onPick={(color) => {
                pickColor(item.id, color)
              }}
              items={item.colors}
              picked={picked}
              open={open}
              setOpen={setOpen}
              title="выберите цвет"
              closeButtonText="Закрыть список цветов"
            />
          </>
        )
      })}
    </div>
  )
}

export default SubSets
